import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { action } from "@ember/object";
import { LinkTo } from "@ember/routing";
import { service } from "@ember/service";
import DTooltip from "discourse/float-kit/components/d-tooltip";
import DButton from "discourse/ui-kit/d-button";
import dConcatClass from "discourse/ui-kit/helpers/d-concat-class";
import { i18n } from "discourse-i18n";
import ChannelTitle from "discourse/plugins/chat/discourse/components/channel-title";

export default class ChatNavbarChannelTitle extends Component {
  @service chatApi;
  @service chatStateManager;
  @service currentUser;

  @tracked isTogglingStarred = false;

  get shouldLinkToSettings() {
    return (
      this.chatStateManager.isDrawerExpanded ||
      this.chatStateManager.isFullPageActive
    );
  }

  get isStarred() {
    return this.args.channel?.currentUserMembership?.starred;
  }

  get starIcon() {
    return this.isStarred ? "star" : "far-star";
  }

  get starTooltip() {
    return this.isStarred
      ? i18n("chat.channel_settings.unstar_channel")
      : i18n("chat.channel_settings.star_channel");
  }

  get showStarButton() {
    return (
      this.currentUser &&
      this.args.channel?.isFollowing &&
      !this.chatStateManager.isDrawerCollapsed
    );
  }

  @action
  async toggleStarred() {
    const channel = this.args.channel;
    if (!channel?.isFollowing || this.isTogglingStarred) {
      return;
    }

    this.isTogglingStarred = true;
    const newValue = !channel.currentUserMembership.starred;
    const previousValue = channel.currentUserMembership.starred;

    channel.currentUserMembership.starred = newValue;

    try {
      await this.chatApi.updateCurrentUserChannelMembership(channel.id, {
        starred: newValue,
      });
    } catch {
      channel.currentUserMembership.starred = previousValue;
    } finally {
      this.isTogglingStarred = false;
    }
  }

  <template>
    {{#if @channel}}
      {{#if this.shouldLinkToSettings}}
        <LinkTo
          class="c-navbar__channel-title"
          @models={{@channel.routeModels}}
          @route="chat.channel.info.settings"
        >
          <ChannelTitle @channel={{@channel}} />
        </LinkTo>
      {{else}}
        <div class="c-navbar__channel-title">
          <ChannelTitle @channel={{@channel}} />
        </div>
      {{/if}}
      {{#if this.showStarButton}}
        <DTooltip @identifier="star-channel" @placement="bottom">
          <:trigger>
            <DButton
              class={{dConcatClass
                "btn-transparent"
                "c-navbar__star-channel-button"
                (if this.isStarred "--starred")
              }}
              @action={{this.toggleStarred}}
              @disabled={{this.isTogglingStarred}}
              @icon={{this.starIcon}}
            />
          </:trigger>
          <:content>
            {{this.starTooltip}}
          </:content>
        </DTooltip>
      {{/if}}
    {{/if}}
  </template>
}
